import signImg from '../../assets/images/Login.jpg';
import logo from '../../assets/images/h_logo.png';
import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';

export default function PreSignup() {
    const [SelCat, setSelCat] = useState('');
    const [step, setStep] = useState(1);
    const [errorMsg, setError] = useState('');
    const navigate = useNavigate();

    const handleSelectCategory = (category) => {
        navigate(`/select_cat/${category.toLowerCase()}`);
    };

    const handleContinue = () => {
        if (!SelCat) {
            setError('Please select an option to continue.');
            return;
        }
        
        // Navigate based on selected user type or advance step
        if (SelCat === 'Talent') {
            navigate('/signup/talent');
        } else if (SelCat === 'Client') {
            navigate('/signup/client');
        }
    };

    return (
        <div>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" />
            <div className="container px-4 text-center">
                <div className="row justify-content-center pb-100 pt-100">
                    <div className="col-md-3 d-none d-md-block">
                        <img src={signImg} alt='' width={350} />
                    </div>
                    <div className="col-md-8">
                        <div className="card bg-white shadow py-3">
                            <div className="card-body">
                                <div className="row justify-content-center" style={{ paddingBottom: 20 }}>
                                    <img src={logo} alt='' style={{ width: 275 }} /><br />
                                    <h4 style={{ fontSize: 24, paddingTop: 20 }}>
                                        {SelCat ? `Join as a ${SelCat}` : "Join as a Client or Talent"}
                                    </h4>
                                    
                                    {errorMsg !== "" && (
                                        <div style={{ color: 'red', fontSize: 16, paddingTop: 7 }}>{errorMsg}</div>
                                    )}
                                </div>

                                {/* Selection Buttons / Cards */}
                                <div className="row justify-content-center my-3 g-3">
                                    <div className="col-md-5">
                                        <div 
                                            className={`card p-4 h-100 cursor-pointer text-center ${SelCat === 'Talent' ? 'border-primary bg-light' : ''}`}
                                            onClick={() => handleSelectCategory('User')}
                                            style={{ cursor: 'pointer', borderWidth: 2 }}
                                        >
                                            <h5 className="fw-bold">Talents</h5>
                                            {/* <p className="text-muted small mb-0">I am looking for work and projects</p> */}
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div 
                                            className={`card p-4 h-100 cursor-pointer text-center ${SelCat === 'Client' ? 'border-primary bg-light' : ''}`}
                                            onClick={() => handleSelectCategory('Client')}
                                            style={{ cursor: 'pointer', borderWidth: 2 }}
                                        >
                                            <h5 className="fw-bold">Client</h5>
                                            {/* <p className="text-muted small mb-0">I want to hire talent for projects</p> */}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {step === 1 && (
                            <div className="card bg-white shadow py-3" style={{ marginTop: 20 }}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <p style={{ color: '#969696', marginBottom: 0 }}>
                                                Already have an account? <Link style={{ color: '#0d6efd' }} to="/">Login</Link>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}